import { useSearchParams } from "react-router-dom";

// Unter-Tabs einer Seite, Auswahl steht in der URL (?tab=...), damit Zurueck/Neu laden passt
export function useSubTab<T extends string>(keys: readonly T[], fallback: T): [T, (t: T) => void] {
  const [params, setParams] = useSearchParams();
  const cur = params.get("tab") as T | null;
  const tab = cur && keys.includes(cur) ? cur : fallback;
  return [tab, (t: T) => setParams(t === fallback ? {} : { tab: t }, { replace: true })];
}

export function SubTabs<T extends string>({ tabs, value, onChange }:
  { tabs: { key: T; label: string }[]; value: T; onChange: (t: T) => void }) {
  return (
    <div className="nx-subtabs" role="tablist">
      {tabs.map(t => (
        <button key={t.key} role="tab" aria-selected={value === t.key}
          className={`nx-subtab${value === t.key ? " active" : ""}`} onClick={() => onChange(t.key)}>
          {t.label}
        </button>
      ))}
    </div>
  );
}
